import React, { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { CountBadge } from 'components/common';
import EntityShareModal from 'components/permissions/EntityShareModal';
import type { CollectionListItem } from 'collections/types';
import { COLLECTIONS_QUERY_KEY } from 'collections/hooks/useCollections';

type Props = Pick<CollectionListItem, 'id' | 'title'> & { shared_with: number };

const SharedWithCell = ({ shared_with, id, title }: Props) => {
  const queryClient = useQueryClient();

  const [showEntityShareModal, setShowEntityShareModal] = useState<boolean>(false);
  const refetchCollections = useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: [COLLECTIONS_QUERY_KEY],
      }),
    [queryClient],
  );

  const toggleEntityShareModal = () => setShowEntityShareModal(!showEntityShareModal);

  const handleShareClose = () => {
    refetchCollections();
    toggleEntityShareModal();
  };

  return (
    <>
      <CountBadge onClick={toggleEntityShareModal} count={shared_with} />
      {showEntityShareModal && (
        <EntityShareModal
          entityId={id}
          entityType="collection_entities"
          entityTypeTitle="Collection Content"
          entityTitle={title}
          description="Search for a User or Team to add as collaborator on this collection's content."
          onClose={handleShareClose}
        />
      )}
    </>
  );
};

export default SharedWithCell;
